module.exports = __webpack_public_path__ + "static/media/instagram.0d2c1756.svg";